'use client';

import { useRef, type ReactNode } from 'react';

import { useNavbarScrollState } from './useNavbarScrollState';

type NavbarScrollStateProps = {
  children: ReactNode;
  className?: string;
  /** When false, skip mobile scroll hide/show + opaque chrome. */
  scrollChrome?: boolean;
};

/**
 * Client header shell: owns the `<header>` ref for mobile scroll-direction
 * chrome (hide on scroll-down from the hero; opaque after swirl done).
 * Server `Navbar` composes this.
 */
export function NavbarScrollState({
  children,
  className,
  scrollChrome = true,
}: NavbarScrollStateProps) {
  const headerRef = useRef<HTMLElement>(null);
  useNavbarScrollState({ headerRef, enabled: scrollChrome });

  return (
    <header ref={headerRef} className={className}>
      {children}
    </header>
  );
}
